export interface IRange {
    start: any;
    end: any;
    isDate?: boolean;
}

export interface IPlotRange {
    start: number;
    end: number;
    isDate?: boolean;
}

export const DEFAULT_RANGE: IPlotRange = {
    start: null,
    end: null,
    isDate: true
};

/** Ensures a variable is a number */
export function convertToNumber( value: number | Date | string, isDate = true ): number {
    if ( isDate ) {
        switch ( typeof value ) {
        case 'string':
        case 'number':
            return new Date( value ).getTime();
        case 'object':
            return value.getTime();
        }
    } else {
        switch ( typeof value ) {
        case 'string':
            return parseInt( value, 10 );
        case 'number':
            return value as number;
        }
    }
}

/** Helps us keep date/number ranges clean. */
export function sanitizeRange( range: IRange ): IPlotRange {
    if ( typeof range.isDate === 'undefined') {
        range.isDate = true;
    }
    return {
        start: convertToNumber( range.start, range.isDate ),
        end: convertToNumber( range.end, range.isDate ),
        isDate: range.isDate
    };
}
